import script from "./affiliate.vue?vue&type=script&setup=true&lang=ts"
export * from "./affiliate.vue?vue&type=script&setup=true&lang=ts"

import "./affiliate.vue?vue&type=style&index=0&id=3ef8e75c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef8e75c"]])

export default __exports__